const faqData = [
  {
    id: 'cost',
    question: 'How much does it cost to have a form completed?',
    answer:
      "There is a minimum fee of $250 for medical records review and physician time. The total cost depends on the type, length, and complexity of the form. You'll receive a quote before any work begins."
  },
  {
    id: 'types',
    question: 'What types of forms do you complete?',
    answer:
      'We complete a wide range of forms, including school absence and return-to-class forms, work accommodation or sick leave forms, disability or insurance forms (e.g., CPP-D, EI), travel cancellation forms, and fitness-to-work or return-to-work clearances.'
  },
  {
    id: 'difference',
    question: "What's the difference between a form and a sick note?",
    answer:
      'A sick note is a simple, standardized certificate for time off work or school. A form is more complex, requiring customized information and a thorough medical history review by your healthcare provider.'
  },
  {
    id: 'doctor',
    question: 'Will I need to speak with the doctor?',
    answer:
      'In some cases, yes. You may be contacted by phone or asked to attend an in-person or virtual appointment before your form can be completed. This is to ensure accuracy and appropriateness of the documentation.'
  },
  {
    id: 'time',
    question: 'How long does it take?',
    answer: 'Most forms are completed within 1-2 business days after payment and submission of all required information. Some cases may require additional time if a consultation is needed.'
  },
  {
    id: 'patient',
    question: 'Do I need to be an existing patient?',
    answer: "No, you don't need to be an existing patient, but we may request additional medical records or information if necessary."
  },
  {
    id: 'privacy',
    question: 'Is my information secure?',
    answer: 'Yes, we are PIPA compliant and follow strict privacy protocols. Your personal health information is handled with the utmost confidentiality and security.'
  },
  {
    id: 'payment',
    question: 'When do I need to pay?',
    answer: "Payment is required before we begin processing your form. You'll receive a quote and can pay securely online through our system."
  },
  {
    id: 'urgent',
    question: 'Can you expedite urgent requests?',
    answer: "We aim to complete most forms within 1-2 business days. For urgent requests, please email info@instoremed.com and we'll do our best to accommodate your timeline."
  },
  {
    id: 'rejected',
    question: 'What if my form request is rejected?',
    answer:
      "Form completion is at the provider's discretion based on available medical information. If we cannot complete your form, we'll explain why and may suggest alternatives or additional steps needed."
  }
];

export default faqData;
